import {useState} from 'react';
import {Autocomplete, TextField} from '@mui/material';
import {timezones} from 'constants/timezones';

const TimezoneSelector = ({onChange}) => {
  const [inputValue, setInputValue] = useState('');

  return (
    <Autocomplete
      options={timezones}
      getOptionLabel={option => {
        // Pick the selected UTC name or default to the first one
        const selectedUtc =
          option.selectedUtc || option.utc[0] || 'Unknown UTC';

        // Convert offset to HH:MM format
        const offsetHours = Math.floor(option.offset);
        const offsetMinutes = (option.offset % 1) * 60; // Convert fraction to minutes
        const offsetSign = option.offset >= 0 ? `+` : `-`;
        const formattedOffset = `${offsetSign}${String(
          Math.abs(offsetHours),
        ).padStart(2, '0')}:${String(Math.abs(offsetMinutes)).padStart(
          2,
          '0',
        )}`;

        return `${option.value} (${selectedUtc}) [UTC ${formattedOffset}]`;
      }}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      filterOptions={(options, {inputValue}) => {
        return options
          .map(option => {
            // Check if any UTC region matches search
            const matchedUtc = option.utc.find(utc =>
              utc.toLowerCase().includes(inputValue.toLowerCase()),
            );

            // If found, attach it for display
            if (matchedUtc) {
              return {...option, selectedUtc: matchedUtc};
            }

            // Also search by timezone name
            if (option.value.toLowerCase().includes(inputValue.toLowerCase())) {
              return {...option, selectedUtc: option.utc[0]};
            }

            return null;
          })
          .filter(Boolean); // Remove null entries
      }}
      onChange={(event, newValue) => onChange(newValue)}
      renderInput={params => (
        <TextField
          {...params}
          label="Select Timezone"
          placeholder="Search by Name or UTC"
        />
      )}
    />
  );
};

export default TimezoneSelector;
